import { useMemo } from "react";
import { useSelector } from "react-redux";
import MemberInfoButton from "./MemberInfoButton";
import i18n from "../../utils/i18n";

import {
  getMembersById,
  getMemberShiftsCount,
  getMemberHoursCount,
  getMemberWithFullInfo,
} from "../../stores/member/memberSelectors";

const ShiftMembersList = ({
  members,
  filterValue = "",
  sortDirection = "asc",
  sortingFn,
  actionButtons,
  displayGlobal = false,
}) => {
  const membersById = useSelector(getMembersById);

  // Filter members by name
  const filterByName = (member) => {
    if (!filterValue || filterValue.length < 1) {
      return true;
    }
    if (member.name) {
      return member.name.toLowerCase().indexOf(filterValue.toLowerCase()) > -1;
    }
    return false;
  };

  // Sort members by strategy
  const sortByStrategy = (member1, member2) => {
    if (sortDirection === "asc") {
      return sortingFn(member1, member2);
    }
    return sortingFn(member2, member1);
  };

  // Get member with full info
  const memberWithFullInfo = (member) => {
    return getMemberWithFullInfo(member, membersById);
  };

  // Render individual member item
  const renderMemberItem = (member) => {
    const shiftsCount = getMemberShiftsCount(member, displayGlobal);
    const hoursCount = getMemberHoursCount(member, displayGlobal);

    return (
      <li key={member.id} className="list-group-item">
        <div className="row">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-12">
                <b>{member.name}</b>
                <MemberInfoButton member={member} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                {i18n.t("schedule.members.shift_count_header")} {shiftsCount}
              </div>
              <div className="col-md-4">
                {i18n.t("schedule.members.hour_count_header")} {hoursCount}
              </div>
            </div>
          </div>
          <div className="col-md-3">{actionButtons(member)}</div>
        </div>
      </li>
    );
  };

  // Memoize sorted and filtered members
  const sortedAndFilteredMembers = useMemo(() => {
    return members
      .map(memberWithFullInfo)
      .filter(filterByName)
      .sort(sortByStrategy);
  }, [members, membersById, filterValue, sortDirection, sortingFn]);

  if (sortedAndFilteredMembers.length > 0) {
    return (
      <ul className="list-group">
        {sortedAndFilteredMembers.map(renderMemberItem)}
      </ul>
    );
  }

  return <p>{i18n.t("schedule.members.empty")}</p>;
};

export default ShiftMembersList;
